// extracted by mini-css-extract-plugin
module.exports = {"title":"GenericCategories_title__oCI5I","categories":"GenericCategories_categories__TrhnO","active":"GenericCategories_active__OL9in"};